export default "__VITE_ASSET__BXpFdEj5__"